import { QueryClient, type QueryClientConfig } from '@tanstack/react-query'
import { StaleTime } from './staleTime'

const QUERY_CLIENT_CONFIG: QueryClientConfig = {
    defaultOptions: {
        queries: {
            gcTime: 6 * StaleTime.Hour,
            refetchOnWindowFocus: false,
            retry: false,
            staleTime: StaleTime.Long,
        },
    },
}

export const queryClient = new QueryClient(QUERY_CLIENT_CONFIG)
